export default __webpack_public_path__ + "static/media/banner3.0ebb7846.jpg";